import type { UIEvent } from '@frontend/react';
import { useState } from '@frontend/react';

export const useFooterVisibility = () => {
  const [isFooterVisible, setIsFooterVisible] = useState(false);

  const handleScroll = (event: UIEvent<HTMLDivElement>) => {
    const scrollContainer = event.currentTarget;

    const scrollTop = scrollContainer.scrollTop;
    const containerHeight = scrollContainer.clientHeight;

    // Check if the user has scrolled beyond the initial viewable area
    if (scrollTop > containerHeight) {
      if (!isFooterVisible) setIsFooterVisible(true);
    } else {
      if (isFooterVisible) setIsFooterVisible(false);
    }
  };

  return { handleScroll, isFooterVisible };
};
